import { perthnow } from './perthnow'
import type { PNThemeOverride } from './perthnow'
import type { PerthNowPalette } from './perthnow/colors'
import { sevennews } from './sevennews'
import type { SevenNewsPalette } from './sevennews/colors'
import { thewest } from './thewest'
import { thenightly } from './thenightly'
import type { TheWestPalette } from './thewest/colors'
import { DesignTokens } from './types'

export type { PerthNowColourMap, PerthNowPalette } from './perthnow/colors'
export type { SevenNewsColourMap, SevenNewsPalette } from './sevennews/colors'
export type { TheWestColourMap, TheWestPalette } from './thewest/colors'
export * from './types'

export const tokens: DesignTokens = {
    thewest,
    perthnow,
    sevennews,
    thenightly,
}

export type ThemeOverride = PNThemeOverride

export type ThemePallete = PerthNowPalette | SevenNewsPalette | TheWestPalette

export * from './perthnow/colors-ngn'
export * from './perthnow/metrics'
